import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BemVindoComponent } from './feature/bem-vindo/index.component';
import { AcessoComponent } from './feature/acesso/index.component';
import { AcessoExternoComponent } from './feature/acesso-externo/index.component';
import { VisualizadorComponent } from './feature/visualizador/visualizador.component';
import { SessaoExpiradaComponent } from './feature/sessao-expirada/sessao-expirada.component';
import { GuardService } from './shared/services/guard-service';
import { AcessoGovBrBronzeComponent } from './feature/acesso-gov-br-bronze/acesso-gov-br-bronze.component';

const routes: Routes = [
  { path: 'acesso', component: AcessoComponent },
  { path: 'acessoExterno', component: AcessoExternoComponent },
  { path: 'acessoGovBrBronze', component: AcessoGovBrBronzeComponent },

  { path: 'bemvindo', component: BemVindoComponent },
  { path: 'visualizador/:idAssinante/:chaveAcesso', component: VisualizadorComponent , canActivate:[GuardService]},
  { path: 'visualizador/:idAssinante/:chaveAcesso/:code', component: VisualizadorComponent , canActivate:[GuardService]},
  { path: 'sessaoExpirada', component: SessaoExpiradaComponent},
  { path: '', redirectTo: '/bemvindo', pathMatch: 'full' }

];

@NgModule({
  imports: [RouterModule.forRoot(routes,  { useHash: true, enableTracing: false, onSameUrlNavigation: 'reload', relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
